import React from "react"
import { Outlet } from "react-router-dom"
import postalfunMarketingScreenshot from "~/images/marketing/postalfun-marketing-screenshot"
import postalFunLogo from "~/images/postal-fun-logo"

export const OnboardingLayout: React.FC = () => {
  return (
    <div className="grid min-h-screen w-full md:grid-cols-2 md:p-9">
      <div className="flex flex-1 flex-col items-center justify-center rounded-s-lg border border-r-0 bg-login-bg px-4 md:px-16">
        <div className="flex w-full max-w-md flex-1 flex-col space-y-8 pb-[80px] pt-[100px]">
          <img {...postalFunLogo} alt="Postal Fun Logo" className="mx-auto mb-16" />
          <div className="flex flex-1 flex-col justify-center pb-32">
            <Outlet />
          </div>
          <div className="flex justify-center space-x-4 pt-8 text-sm text-gray-500">
            <a href="#" className="underline">
              Privacy Policy
            </a>
            <span>&</span>
            <a href="#" className="underline">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
      <div
        className="hidden flex-1 rounded-e-lg md:block"
        style={{ background: "linear-gradient(324.29deg, #2E8DBB 0%, #3C2C95 80%)" }}
      >
        <div className="flex h-full items-center justify-center ps-[42px] pt-[69px]">
          <img
            {...postalfunMarketingScreenshot}
            alt="Screenshot of Postal Fun"
            className="max-h-full max-w-full object-contain"
          />
        </div>
      </div>
    </div>
  )
}
